<script>
export default {
    data() {
        return {
            selected: 'residential'
        };
    },
    methods: {
        filterUpdate(filter) {
            this.selected = filter;
            location.hash = filter;
            this.$parent.filter = filter;
            this.$parent.applyFilter();
        }
    }
};
</script>

<style lang="scss">
.filter {
    &:hover {
        button {
            @apply text-gray-400;

            &:hover {
                @apply text-shark-200;
            }
        }
    }
}
</style>
